export const CHECKOUT_URL = 'https://tennis-360.impultienda.ar/checkout'
